import { render, staticRenderFns } from "./BiddingLimit.vue?vue&type=template&id=585add36&scoped=true"
import script from "./BiddingLimit.vue?vue&type=script&lang=js"
export * from "./BiddingLimit.vue?vue&type=script&lang=js"
import style0 from "./BiddingLimit.vue?vue&type=style&index=0&id=585add36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585add36",
  null
  
)

export default component.exports